// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__ql7ul","rotate":"Loader_rotate__661yD"};